import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color } = theme;

const wrap = (justifyContent: string): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent,
  alignItems: 'center',
  gap: 8,
  background: color.white,
  '> h2': {
    fontSize: '18px',
    fontWeight: 700,
    color: color.text,
  },
  '>p': {
    color: color.textMuted,
    fontSize: '14px',
    fontWeight: 'normal',
    marginLeft: '4px',
    span: {
      color: color.text,
      fontWeight: 600,
    },
  },
});

export { wrap };
